// Tipos para integração com o backend
export interface Imovel {
  id: string;
  codigo: number;
  titulo: string;
  descricao: string;
  tipo_imovel: TipoImovel;
  endereco: string;
  cidade: string;
  estado: string;
  cep: string;
  bairro?: string;
  latitude?: number;
  longitude?: number;
  quartos: number;
  banheiros: number;
  vagas_garagem: number;
  area_util: number;
  valor_aluguel: number | null;
  valor_venda?: number | null;
  valor_condominio?: number;
  valor_iptu?: number;
  aceita_pet: boolean;
  mobiliado: boolean;
  ar_condicionado: boolean;
  internet: boolean;
  modalidade_aluguel?: ModalidadeAluguel; // Mantido para compatibilidade durante transição
  modalidades?: ModalidadeAluguelCompleta[]; // Array de modalidades (novo formato)
  comodidades: string[];
  status: StatusImovel;
  // Propriedades adicionais para detalhes do imóvel
  box?: boolean;
  varanda?: boolean;
  armarios_quarto?: boolean;
  armarios_banheiro?: boolean;
  armarios_cozinha?: boolean;
  chuveiro_gas?: boolean;
  fogao_incluso?: boolean;
  geladeira_inclusa?: boolean;
  banheiro_adaptado?: boolean;
  cozinha_americana?: boolean;
  home_office?: boolean;
  portas_amplas?: boolean;
  hidromassagem?: boolean;
  piscina_privativa?: boolean;
  cobertura?: boolean;
  closet?: boolean;
  jardim?: boolean;
  quintal?: boolean;
  casa_unica?: boolean;
  area_servico?: boolean;
  area_privativa?: boolean;
  motivo_rejeicao?: string;
  locador_id: string;
  locador: Usuario;
  midias: Midia[];
  created_at: string;
  updated_at: string;
}

export enum TipoImovel {
  APARTAMENTO = 'apartamento',
  CASA = 'casa',
  KITNET = 'kitnet',
  STUDIO = 'studio',
  LOFT = 'loft',
  DUPLEX = 'duplex',
  COBERTURA = 'cobertura',
  TERRENO = 'terreno',
  COMERCIAL = 'comercial',
  GALPAO = 'galpao'
}

export enum ModalidadeAluguel {
  DEPOSITO_CAUCAO = 'deposito_caucao',
  CARTA_FIANCA = 'carta_fianca',
  TITULO_CAPITALIZACAO = 'titulo_capitalizacao',
  SEGURO_FIANCA = 'seguro_fianca',
  FIADOR = 'fiador'
}

// Interface completa para modalidade retornada pela API
export interface ModalidadeAluguelCompleta {
  id: string;
  tipo: string; // Tipo da modalidade (ex: 'deposito_caucao')
  nome: string; // Nome formatado (ex: 'Depósito Caução')
  descricao?: string; // Descrição da modalidade
  created_at: string;
  updated_at: string;
}

// Opções de modalidades para seleção no formulário
export const MODALIDADES_OPCOES: Array<{
  value: ModalidadeAluguel;
  label: string;
  description: string;
}> = [
  {
    value: ModalidadeAluguel.DEPOSITO_CAUCAO,
    label: 'Depósito Caução',
    description: 'Pagamento de depósito como garantia'
  },
  {
    value: ModalidadeAluguel.CARTA_FIANCA,
    label: 'Carta Fiança',
    description: 'Garantia bancária através de carta fiança'
  },
  {
    value: ModalidadeAluguel.TITULO_CAPITALIZACAO,
    label: 'Título de Capitalização',
    description: 'Título de capitalização como garantia'
  },
  {
    value: ModalidadeAluguel.SEGURO_FIANCA,
    label: 'Seguro Fiança',
    description: 'Seguro específico para aluguel'
  },
  {
    value: ModalidadeAluguel.FIADOR,
    label: 'Fiador',
    description: 'Fiador físico com renda comprovada'
  }
];

export enum StatusImovel {
  PENDENTE = 'pendente',
  APROVADO = 'aprovado',
  REJEITADO = 'rejeitado',
  DISPONIVEL = 'disponivel',
  ALUGADO = 'alugado',
  INATIVO = 'inativo',
  PAUSADO = 'pausado',
  VENDIDO = 'vendido'
}

export interface Midia {
  id: string;
  url: string;
  tipo: TipoMidia;
  titulo?: string;
  descricao?: string;
  ordem: number;
  is_capa?: boolean;
  ativa: boolean;
  imovel_id: string;
  created_at: string;
  updated_at: string;
}

export enum TipoMidia {
  IMAGEM = 'imagem',
  VIDEO = 'video'
}

export interface Usuario {
  id: string;
  nome: string;
  email: string;
  telefone?: string;
  cpf_cnpj?: string;
  role: UserRole;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

export enum UserRole {
  ADMIN = 'admin',
  LOCADOR = 'locador',
  LOCATARIO = 'locatario'
}

export interface PropertySearchFilters {
  cidade?: string;
  estado?: string;
  bairro?: string;
  tipo?: string;
  tipo_imovel?: string;
  quartos?: number;
  quartos_min?: number;
  quartos_max?: number;
  banheiros?: number;
  banheiros_min?: number;
  banheiros_max?: number;
  vagas_garagem?: number;
  vagas_min?: number;
  vagas_max?: number;
  area_min?: number;
  area_max?: number;
  valor_min?: number;
  valor_max?: number;
  valorMaximo?: string | number;
  valor_venda_min?: number;
  valor_venda_max?: number;
  apenas_aluguel?: boolean;
  apenas_venda?: boolean;
  aluguel_e_venda?: boolean;
  aceita_pet?: boolean;
  mobiliado?: boolean;
  ar_condicionado?: boolean;
  internet?: boolean;
  comodidades?: string[];
  search?: string;
  page?: number;
  limit?: number;
}

export interface PaginationData {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PropertySearchResponse {
  imoveis: Imovel[];
  pagination: PaginationData;
}